import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  size?: 'sm' | 'md';
}

/** Yalnızca ikon içeren, erişilebilir (aria-label) düğme. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ label, className, size = 'md', ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      title={label}
      className={cn(
        'text-fg-muted hover:bg-bg-hover hover:text-fg focus-visible:ring-ring inline-flex items-center justify-center rounded-md focus-visible:ring-2 focus-visible:outline-none disabled:opacity-50',
        size === 'sm' ? 'h-8 w-8' : 'h-9 w-9',
        className,
      )}
      {...props}
    />
  ),
);
IconButton.displayName = 'IconButton';
